"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    ValueSetClient: Symbol("ValueSetClient"),
    ValueSetItemClient: Symbol("ValueSetItemClient"),
    ValueSetItemRoute: Symbol("ValueSetItemRoute"),
    ValueSetRoute: Symbol("ValueSetRoute")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.ValueSetItemRoute).to(_1.ValueSetItemRoute);
    bind(TYPES.ValueSetItemClient).to(_1.ValueSetItemClient);
    bind(TYPES.ValueSetRoute).to(_1.ValueSetRoute);
    bind(TYPES.ValueSetClient).to(_1.ValueSetClient);
});
exports.diModule = diModule;
